import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetMediaTypes =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_types.get;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteMediaTypes =
  ({ mediaTypeId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_types.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaTypeId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageMediaTypes =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      var bodyData = {};

      if (CheckDataIfExit(values?.type_name)) {
        bodyData.type_name = values?.type_name?.trim();
      }
      const response = await PostFunction({
        data: bodyData,
        Route: editMode
          ? `${UrlApi.media_types.edit}/${paramID}`
          : UrlApi.media_types.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };
